export default {
  "Previous month": "الشهر السابق",
  "Price": "السعر",
  "Price (e.g. 49.00)": "السعر (مثال: 49.00)",
  "Price Adjustment (": "تعديل السعر (",
  "Price Adjustment ($)": "تعديل السعر ($)",
  "Price adjustment:": "تعديل السعر:",
  "Price updated": "تم تحديث السعر",
  "Price:": "السعر:",
  "Price: high to low": "السعر: من الأعلى إلى الأقل",
  "Price: low to high": "السعر: من الأقل إلى الأعلى",
  "Prices converted {from} → {to} at {v2}. Existing orders were kept unchanged.": "تم تحويل الأسعار من {from} إلى {to} بسعر {v2}. بقيت الطلبات الحالية دون تغيير.",
  "Primary": "الأساسي",
  "Primary Color": "اللون الأساسي",
  "Print": "طباعة",
  "Print Bill": "طباعة الفاتورة",
  "Print Customer Bill": "طباعة فاتورة العميل",
  "Print Invoice": "طباعة الفاتورة",
  "Print QR": "طباعة QR",
  "Print QR Code": "طباعة رمز QR",
  "Print QR 🖨️": "طباعة QR 🖨️",
  "Print your QR code or share your website link and start taking orders.": "اطبع رمز QR أو شارك رابط موقعك وابدأ في استقبال الطلبات.",
  "Printed:": "تاريخ الطباعة:",
  "Printer": "الطابعة",
  "Printer IP Address": "عنوان IP للطابعة",
  "Printer Port": "منفذ الطابعة",
  "Printer Settings": "إعدادات الطابعة",
  "Printer {printerId} error: {error}": "خطأ في الطابعة {printerId}: {error}",
  "Proceed to Payment": "المتابعة إلى الدفع",
  "Process Card Payment": "معالجة الدفع بالبطاقة",
  "Processing Card...": "جارٍ معالجة البطاقة...",
  "Processing...": "جارٍ المعالجة...",
  "Product": "المنتج",
  "Product Management": "إدارة المنتجات",
  "Product Variants": "خيارات المنتج",
  "Product details": "تفاصيل المنتج",
  "Product photos gallery and variants": "معرض صور المنتجات والخيارات",
  "Product stock": "مخزون المنتجات",
  "Products": "المنتجات",
  "Products, stock, cart and online payments.": "منتجات ومخزون وسلة ومدفوعات إلكترونية.",
  "Professional - Clinic Directory": "احترافي - دليل العيادة",
  "Program settings": "إعدادات البرنامج",
  "Progress": "التقدم",
  "QR Code": "رمز QR",
  "QR Code not found!": "لم يتم العثور على رمز QR!",
  "QR menu and table ordering": "قائمة QR والطلب من الطاولة",
  "QR menu, table ordering, kitchen display": "قائمة QR، طلب من الطاولة، شاشة مطبخ",
  "QR menus, POS, kitchen screen and reservations.": "قوائم QR ونقطة بيع وشاشة مطبخ وحجوزات.",
  "QUICK ADD": "إضافة سريعة",
  "Qty": "الكمية",
  "Quantity": "الكمية",
  "Quantity Sold": "الكمية المباعة",
  "Quantity in stock": "الكمية في المخزون",
  "Quantity in stock for {name}": "الكمية في المخزون لـ {name}",
  "Quantity per serving": "الكمية لكل حصة",
  "Quantity:": "الكمية:",
  "Questions, answered": "أسئلة وأجوبة",
  "Queuing...": "جارٍ الجدولة...",
  "Quick Order Search": "بحث سريع عن طلب",
  "READY": "جاهز",
  "REQUEST RECEIVED": "تم استلام الطلب",
  "RESTAURANT BILL": "فاتورة المطعم",
  "Rank": "الترتيب",
  "Reactivate": "إعادة التفعيل",
  "Reactivate restaurant": "إعادة تفعيل المطعم",
  "Ready": "جاهز",
  "Ready for Service": "جاهز للتقديم",
  "Ready in minutes.": "جاهز خلال دقائق.",
  "Ready to open online?": "هل أنت جاهز للانطلاق عبر الإنترنت؟",
  "Ready to redeem": "جاهز للاستبدال",
  "Real-time order management •": "إدارة الطلبات لحظيًا •",
  "Reason": "السبب",
  "Reason (optional)": "السبب (اختياري)",
  "Reason (shown to the customer)": "السبب (يظهر للعميل)",
  "Reason given: “": "السبب: “",
  "Receipt rejected - the customer can upload a new one": "تم رفض الإيصال - يمكن للعميل رفع إيصال جديد",
  "Receipt sent. The store will verify it shortly.": "تم إرسال الإيصال. سيتحقق المتجر منه قريبًا.",
  "Recent Activity": "النشاط الأخير",
  "Recent Orders": "أحدث الطلبات",
  "Recent orders": "أحدث الطلبات",
  "Recipe Management": "إدارة الوصفات",
  "Recipe created with {length} ingredient{v1}": "تم إنشاء الوصفة بعدد مكونات: {length}",
  "Recipe for \"{menuItem}\" deleted successfully": "تم حذف وصفة \"{menuItem}\" بنجاح",
  "Recipe ingredient deleted successfully": "تم حذف مكوّن الوصفة بنجاح",
  "Recipe updated with {length} ingredient{v1}": "تم تحديث الوصفة بعدد مكونات: {length}",
  "Recipes (": "الوصفات (",
  "Recipes and ingredient stock": "الوصفات ومخزون المكونات",
  "Reconnecting to WhatsApp (": "إعادة الاتصال بواتساب (",
  "Redirecting to Stripe...": "جارٍ التحويل إلى Stripe...",
  "Ref:": "المرجع:",
  "Refresh": "تحديث",
  "Refresh Data": "تحديث البيانات",
  "Refund Count": "عدد الاستردادات",
  "Reject": "رفض",
  "Reject receipt": "رفض الإيصال",
  "Remove": "حذف",
  "Remove everything from your cart?": "إزالة كل شيء من سلتك؟",
  "Remove ingredient": "حذف المكوّن",
  "Remove item": "حذف العنصر",
  "Remove photo": "حذف الصورة",
  "Remove {name}": "حذف {name}",
  "Report": "التقرير",
  "Report exported successfully": "تم تصدير التقرير بنجاح",
  "Reports": "التقارير",
  "Reports & Analytics": "التقارير والتحليلات",
  "Request appointment": "طلب موعد",
  "Request reservation": "طلب حجز",
  "Request your appointment": "اطلب موعدك",
  "Requesting your table…": "جارٍ طلب طاولتك…",
  "Reservation #": "حجز رقم ",
  "Reservations": "الحجوزات",
  "Reserve": "احجز",
  "Reserve a table": "احجز طاولة",
  "Reset": "إعادة تعيين",
  "Restaurant": "مطعم",
  "Restaurant / Cafe": "مطعم / مقهى",
  "Restaurant Bill": "فاتورة المطعم",
  "Restaurant Information": "معلومات المطعم",
  "Restaurant Name *": "اسم المطعم *",
  "Restaurant Not Found": "المطعم غير موجود",
  "Restaurant Portfolio": "محفظة المطاعم",
  "Restaurant Settings": "إعدادات المطعم",
  "Restaurant created successfully!": "تم إنشاء المطعم بنجاح!",
  "Restaurant creation form will be implemented next...": "سيتم تنفيذ نموذج إنشاء المطعم لاحقًا...",
  "Restaurant is Active": "المطعم نشط",
  "Restaurant operations overview": "نظرة عامة على عمليات المطعم",
  "Restaurant updated successfully!": "تم تحديث المطعم بنجاح!",
  "Restaurants": "المطاعم",
  "Restaurants & cafés": "المطاعم والمقاهي",
  "Restaurants, stores and bookings in one place": "المطاعم والمتاجر والحجوزات في مكان واحد",
  "Restore": "استعادة",
  "Restore this backup": "استعادة هذه النسخة",
  "Retry": "إعادة المحاولة",
  "Revenue": "الإيرادات",
  "Revenue from members": "إيرادات الأعضاء",
  "Reward created": "تم إنشاء المكافأة",
  "Rewards & Settings": "المكافآت والإعدادات",
  "Rewards catalog": "كتالوج المكافآت",
  "Role": "الدور",
  "Role *": "الدور *",
  "Room bookings by date and time slot": "حجز الغرف حسب التاريخ والوقت",
  "Rooms and desks by the hour or day": "غرف ومكاتب بالساعة أو اليوم",
  "Rounded photos • Soft serif • Cozy palette": "صور دائرية • خطوط ناعمة • ألوان دافئة",
  "Row": "الصف",
  "Row deleted": "تم حذف الصف",
  "Run your restaurant, store or bookings from one place.": "أدر مطعمك أو متجرك أو حجوزاتك من مكان واحد.",
  "SEARCH": "بحث",
  "SERVED": "تم التقديم",
  "SHOP": "تسوّق",
  "SKU": "SKU",
  "SKU (Optional)": "SKU (اختياري)",
  "SKU:": "SKU:",
  "SORT": "ترتيب",
  "SQLite Database": "قاعدة بيانات SQLite",
  "SUBTOTAL:": "المجموع الفرعي:",
  "Salary": "الراتب",
  "Sales Range": "مبيعات الفترة",
  "Sales range loaded successfully": "تم تحميل مبيعات الفترة بنجاح",
  "Save": "حفظ",
  "Save Changes": "حفظ التغييرات",
  "Save Recipe": "حفظ الوصفة",
  "Save Settings": "حفظ الإعدادات",
  "Save changes": "حفظ التغييرات",
  "Save hours": "حفظ الساعات",
  "Save payment methods": "حفظ طرق الدفع",
  "Save settings": "حفظ الإعدادات",
  "Saved ({secretKeyHint}) - leave blank to keep": "محفوظ ({secretKeyHint}) - اتركه فارغًا للإبقاء عليه",
  "Saving theme…": "جارٍ حفظ الثيم…",
  "Saving...": "جارٍ الحفظ...",
  "Scan QR code to order • Pay at cashier": "امسح رمز QR للطلب • الدفع عند الكاشير",
  "Scan or search for orders to confirm payments": "امسح الطلبات أو ابحث عنها لتأكيد الدفع",
  "Scan to order": "امسح للطلب",
  "Scan to visit your website": "امسح لزيارة موقعك",
  "Scan with WhatsApp on your phone": "امسح باستخدام واتساب على هاتفك",
  "Schedule": "الجدول",
  "Search": "بحث",
  "Search Google Images": "البحث في صور Google",
  "Search Order": "البحث عن طلب",
  "Search by name or phone...": "ابحث بالاسم أو الهاتف...",
  "Search by name, username, or role...": "ابحث بالاسم أو اسم المستخدم أو الدور...",
  "Search for images (e.g., pizza, burger, coffee)": "ابحث عن صور (مثال: بيتزا، برغر، قهوة)",
  "Search for images to get started": "ابحث عن صور للبدء",
  "Search for something you love…": "ابحث عن شيء تحبه…",
  "Search logs...": "ابحث في السجلات...",
  "Search menu": "ابحث في القائمة",
  "Search menu items...": "ابحث في عناصر القائمة...",
  "Search orders": "ابحث في الطلبات",
  "Search products": "ابحث في المنتجات",
  "Search services": "ابحث في الخدمات",
  "Search the collection": "ابحث في التشكيلة",
  "Searching...": "جارٍ البحث...",
  "Secondary": "الثانوي",
  "Secondary Color": "اللون الثانوي",
  "Secret key": "المفتاح السري",
  "Secure password": "كلمة مرور آمنة",
  "See how it works": "شاهد كيف يعمل",
  "Select Options": "اختر الخيارات",
  "Select Table": "اختر الطاولة",
  "Select a category": "اختر تصنيفًا",
  "Select a menu item": "اختر عنصرًا من القائمة",
  "Select a plan...": "اختر خطة...",
  "Select a report type": "اختر نوع التقرير",
  "Select an image from the results": "اختر صورة من النتائج",
  "Select ingredient": "اختر المكوّن",
  "Selected": "محدد",
  "Selected for you": "مختار لك",
  "Selected:": "المحدد:",
  "Sell products with a cart and checkout": "بِع منتجاتك مع سلة ودفع إلكتروني",
  "Send campaign": "إرسال الحملة",
  "Send this link to the restaurant to start their subscription (14-day trial included).": "أرسل هذا الرابط إلى المطعم لبدء اشتراكه (يشمل تجربة لمدة 14 يومًا).",
  "Sends to customers who opted into marketing only, one message every 60 seconds.": "يُرسل فقط للعملاء الموافقين على التسويق، رسالة واحدة كل 60 ثانية.",
  "Sent to the business email below when an item reaches its minimum stock.": "يُرسل إلى بريد النشاط أدناه عندما يصل عنصر إلى الحد الأدنى للمخزون.",
  "Served": "تم التقديم",
  "Service": "الخدمة",
  "Service Charge": "رسوم الخدمة",
  "Service Charge (%)": "رسوم الخدمة (%)",
  "Service Charge:": "رسوم الخدمة:",
  "Service cards with a friendly how-it-works panel": "بطاقات خدمات مع لوحة ودّية تشرح طريقة العمل",
  "Service charge": "رسوم الخدمة",
  "Service created": "تم إنشاء الخدمة",
  "Service deleted": "تم حذف الخدمة",
  "Service name": "اسم الخدمة",
  "Service updated": "تم تحديث الخدمة",
  "Service:": "الخدمة:",
  "Services": "الخدمات",
  "Services, staff and opening hours": "الخدمات والموظفون وساعات العمل",
  "Set price": "تحديد السعر",
  "Settings": "الإعدادات",
  "Settings saved successfully!": "تم حفظ الإعدادات بنجاح!",
  "Shadow Intensity": "شدة الظل",
  "Share your link": "شارك رابطك",
  "Shop the collection": "تسوّق التشكيلة",
  "Shopping cart": "سلة التسوق",
  "Show password": "إظهار كلمة المرور",
  "Show secret key": "إظهار المفتاح السري",
  "Showing": "عرض",
  "Sidebar Width (px)": "عرض الشريط الجانبي (px)",
  "Sign in": "تسجيل الدخول",
  "Sign in to manage your business, website and orders.": "سجّل الدخول لإدارة نشاطك وموقعك وطلباتك.",
  "Sign in with the phone number you used to register.": "سجّل الدخول برقم الهاتف الذي استخدمته عند التسجيل.",
  "Sign out": "تسجيل الخروج",
  "Sign-in method": "طريقة تسجيل الدخول",
  "Signing in...": "جارٍ تسجيل الدخول...",
  "Since": "منذ",
  "Size:": "الحجم:",
  "Skip": "تخطي",
  "Skip to content": "انتقل إلى المحتوى",
  "Slow down. Breathe.": "تمهّل. تنفّس.",
  "Snapchat": "سناب شات",
  "So we know what to call you": "لنعرف كيف نناديك",
  "Social media": "وسائل التواصل الاجتماعي",
  "Soft light, quiet rooms, and an hour that is only yours.": "إضاءة ناعمة، غرف هادئة، وساعة لك وحدك.",
  "Something went wrong. Please try again.": "حدث خطأ ما. حاول مرة أخرى.",
  "Sorry, \"{name}\" is out of stock": "عذرًا، نفد مخزون \"{name}\"",
  "Sort": "ترتيب",
  "Sort Order": "ترتيب العرض",
  "Sort products": "ترتيب المنتجات",
  "Special Instructions": "تعليمات خاصة",
  "Spent": "المُنفَق",
  "Split hero, category chips and a product grid - works for any catalog": "واجهة مقسومة وشرائح تصنيفات وشبكة منتجات - يناسب أي كتالوج",
  "Staff PIN for quick sign-in at the POS or kitchen.": "رمز PIN للموظفين لتسجيل الدخول السريع عند نقطة البيع أو المطبخ.",
  "Start Cooking": "ابدأ الطهي",
  "Start Prep": "ابدأ التحضير",
  "Start free": "ابدأ مجانًا",
  "Start with this template": "ابدأ بهذا القالب",
  "Status": "الحالة",
  "Status:": "الحالة:",
  "Steakhouse - Grill & BBQ": "ستيك هاوس - مشويات وباربكيو",
  "Sticky category sidebar that follows your scroll, wide photo cards": "شريط تصنيفات جانبي ثابت يتبعك أثناء التمرير، وبطاقات صور عريضة",
  "Stock Item": "عنصر المخزون",
  "Stock Items": "عناصر المخزون",
  "Stock Items (": "عناصر المخزون (",
  "Stock goes down automatically with every order and comes back if an order is cancelled.": "ينخفض المخزون تلقائيًا مع كل طلب ويعود عند إلغاء الطلب.",
  "Stock item created successfully": "تم إنشاء عنصر المخزون بنجاح",
  "Stock item deleted successfully": "تم حذف عنصر المخزون بنجاح",
  "Stock item updated successfully": "تم تحديث عنصر المخزون بنجاح",
  "Stock movement recorded successfully": "تم تسجيل حركة المخزون بنجاح",
  "Stock updated": "تم تحديث المخزون",
  "Stock:": "المخزون:",
  "Store Overview": "نظرة عامة على المتجر",
  "Store Templates": "قوالب المتجر",
  "Stored encrypted. It is never shown again or sent to customers.": "يُخزَّن مشفرًا. لن يُعرض مرة أخرى ولن يُرسل للعملاء.",
  "Stripe confirms the card payment": "يؤكد Stripe الدفع بالبطاقة",
  "Stripe has no completed payment for this order yet": "لا يوجد دفع مكتمل لهذا الطلب في Stripe بعد",
  "Subheading": "العنوان الفرعي",
  "Subscribe below to add a card or bank account.": "اشترك أدناه لإضافة بطاقة أو حساب بنكي.",
  "Subscribe monthly": "اشترك شهريًا",
  "Subscription Plans": "خطط الاشتراك",
  "Subscription actions": "إجراءات الاشتراك",
  "Subscription started. Thank you!": "بدأ الاشتراك. شكرًا لك!",
  "Subscription status": "حالة الاشتراك",
  "Subscription will cancel at period end": "سيتم إلغاء الاشتراك في نهاية الفترة",
  "Subtotal": "المجموع الفرعي",
  "Subtotal:": "المجموع الفرعي:",
  "Success Color": "لون النجاح",
  "Summary": "الملخص",
  "Surface Color": "لون السطح",
  "Sushi - Japanese Minimal": "سوشي - ياباني بسيط",
  "Suspend": "تعليق",
  "Suspend restaurant": "تعليق المطعم",
  "System": "النظام",
  "TABLE": "طاولة",
  "TABLE {table} · ": "طاولة {table} · ",
  "TAKEAWAY": "سفري",
  "THANK YOU FOR DINING WITH US!": "شكرًا لتناولكم الطعام معنا!",
  "THANK YOU! 🎉": "شكرًا لك! 🎉",
  "THE EDIT": "المختارات",
  "THE LAST LITTLE STEP": "الخطوة الأخيرة",
  "TOTAL": "الإجمالي",
  "TOTAL:": "الإجمالي:",
  "Tab": "Tab",
  "Table": "الطاولة",
  "Table #": "طاولة رقم ",
  "Table Management": "إدارة الطاولات",
  "Table Number": "رقم الطاولة",
  "Table Number *": "رقم الطاولة *",
  "Table Turnover": "دوران الطاولات",
  "Table View": "عرض الجدول",
  "Table deleted successfully": "تم حذف الطاولة بنجاح",
  "Table link copied to clipboard!": "تم نسخ رابط الطاولة!",
  "Table number": "رقم الطاولة",
  "Table turnover loaded successfully": "تم تحميل دوران الطاولات بنجاح",
  "Table {table_number}": "طاولة {table_number}",
  "Table {table_number} QR Code": "رمز QR للطاولة {table_number}",
  "Table {table}": "طاولة {table}",
  "Table {v0} successfully": "تم {v0} الطاولة بنجاح",
  "Table:": "الطاولة:",
  "Tables": "الطاولات",
  "Take Out": "سفري",
  "Takeaway": "سفري",
  "Tasting Menu": "قائمة التذوق",
  "Tax": "الضريبة",
  "Tax Rate": "نسبة الضريبة",
  "Tax Rate (%)": "نسبة الضريبة (%)",
  "Tax:": "الضريبة:",
  "Taxes and any service charge are added at checkout.": "تُضاف الضرائب ورسوم الخدمة عند إتمام الطلب.",
  "Tel:": "هاتف:",
  "Template": "القالب",
  "Template Preview": "معاينة القالب",
  "Test Connection": "اختبار الاتصال",
  "Test mode: no real money is charged. Use card 4242 4242 4242 4242 to try a payment.": "وضع الاختبار: لا يتم خصم أموال حقيقية. استخدم البطاقة 4242 4242 4242 4242 لتجربة الدفع.",
  "Testing...": "جارٍ الاختبار...",
  "Text displayed at the bottom of the menu page": "النص المعروض أسفل صفحة القائمة",
  "Text displayed at the top of the menu page": "النص المعروض أعلى صفحة القائمة",
  "Thank You!": "شكرًا لك!",
  "Thank you for choosing us!": "شكرًا لاختيارك لنا!",
  "Thank you for dining with us": "شكرًا لتناولك الطعام معنا",
  "Thank you for your order!": "شكرًا لطلبك!",
  "Thank you for your visit!": "شكرًا لزيارتك!",
  "Thank you,": "شكرًا لك،",
  "The Grill": "المشواة",
  "The Menu": "القائمة",
  "The customer chose bank transfer. Their receipt will appear here as soon as they upload it.": "اختار العميل التحويل البنكي. سيظهر الإيصال هنا فور رفعه.",
  "The edit · No. 01 ·": "المختارات · رقم 01 ·",
  "The file is too large (max 8 MB)": "الملف كبير جدًا (الحد الأقصى 8 ميغابايت)",
  "The language of your public website, menu, cart and checkout. Arabic shows the site right-to-left.": "لغة موقعك العام والقائمة والسلة والدفع. العربية تعرض الموقع من اليمين إلى اليسار.",
  "The product was saved, but some gallery photos failed to upload": "تم حفظ المنتج، لكن تعذر رفع بعض صور المعرض",
  "The receipt could not be loaded.": "تعذر تحميل الإيصال.",
  "The store verified your bank transfer.": "تحقق المتجر من تحويلك البنكي.",
  "The store will confirm delivery availability and timing with you.": "سيؤكد المتجر معك توفر التوصيل وموعده.",
  "Theme": "الثيم",
  "Theme Colors": "ألوان الثيم",
  "Theme upload failed": "فشل رفع الثيم",
  "Theme uploaded and saved": "تم رفع الثيم وحفظه",
  "These photos are uploaded when you save the product.": "سيتم رفع هذه الصور عند حفظ المنتج.",
  "Thin typography • Whitespace • One red accent": "خطوط رفيعة • مساحات بيضاء • لمسة حمراء واحدة",
  "This Month": "هذا الشهر",
  "This Year": "هذا العام",
  "This address will appear on invoices and receipts": "سيظهر هذا العنوان على الفواتير والإيصالات",
  "This becomes your subdomain and shows to customers.": "سيصبح هذا نطاقك الفرعي ويظهر للعملاء.",
  "This is how you'll log in and manage": "بهذه البيانات ستسجّل الدخول وتدير",
  "This mirrors your homepage's hero section - the full page (product grid, categories, etc.) uses your selected template.": "هذه معاينة لواجهة صفحتك الرئيسية - الصفحة الكاملة (شبكة المنتجات والتصنيفات وغيرها) تستخدم القالب الذي اخترته.",
  "This product could not be found": "تعذر العثور على هذا المنتج",
  "This product could not be found.": "تعذر العثور على هذا المنتج.",
  "This store": "هذا المتجر",
  "TikTok": "تيك توك",
  "Time": "الوقت",
  "Time:": "الوقت:",
  "Times on": "الأوقات في",
  "Times shown in": "الأوقات معروضة بتوقيت",
  "Timezone": "المنطقة الزمنية",
  "To:": "إلى:",
  "Today": "اليوم",
  "Today's Menu": "قائمة اليوم",
  "Today's Revenue": "إيرادات اليوم",
  "Today's Sales": "مبيعات اليوم",
  "Today's performance at a glance": "أداء اليوم في لمحة",
  "Today's sales": "مبيعات اليوم",
  "Top Items": "الأكثر مبيعًا",
  "Top Products": "أفضل المنتجات",
  "Top Selling Products": "المنتجات الأكثر مبيعًا",
  "Top items loaded successfully": "تم تحميل العناصر الأكثر مبيعًا بنجاح",
  "Total": "الإجمالي",
  "Total Active": "إجمالي النشطين",
  "Total Amount": "المبلغ الإجمالي",
  "Total Amount:": "المبلغ الإجمالي:",
  "Total Cash Received": "إجمالي النقد المستلم",
  "Total Consumed": "إجمالي المستهلك",
  "Total Employees": "إجمالي الموظفين",
  "Total Menu Items": "إجمالي عناصر القائمة",
  "Total Orders": "إجمالي الطلبات",
  "Total Received": "إجمالي المستلم",
  "Total Recipes": "إجمالي الوصفات",
  "Total Refunds": "إجمالي الاستردادات",
  "Total Restaurants": "إجمالي المطاعم",
  "Total Revenue": "إجمالي الإيرادات",
  "Total Tables": "إجمالي الطاولات",
  "Total Tax": "إجمالي الضريبة",
  "Total cells:": "إجمالي الخلايا:",
  "Total members": "إجمالي الأعضاء",
  "Total:": "الإجمالي:",
  "Track": "تتبّع",
  "Track all actions across your restaurants": "تتبّع جميع الإجراءات في مطاعمك",
  "Track an order": "تتبّع طلبًا",
  "Track stock for this item": "تتبّع المخزون لهذا العنصر",
  "Track your order": "تتبّع طلبك",
  "Tracking PIN": "رمز PIN للتتبع",
  "Transaction Count": "عدد المعاملات",
  "Transfer receipt uploaded for {v0}": "تم رفع إيصال التحويل للطلب {v0}",
  "Transfer the total to the account below, then upload a photo or screenshot of the receipt.": "حوّل المبلغ الإجمالي إلى الحساب أدناه، ثم ارفع صورة أو لقطة شاشة للإيصال.",
  "Treatment menu": "قائمة العلاجات",
  "Trust badges, department filter and a table of services - clinics, offices": "شارات ثقة، وفلتر أقسام، وجدول خدمات - للعيادات والمكاتب",
  "Try a different search term": "جرّب كلمة بحث مختلفة",
  "Try again": "حاول مرة أخرى",
  "Try another search or explore all categories.": "جرّب بحثًا آخر أو تصفح جميع التصنيفات.",
  "Type": "النوع",
  "Type:": "النوع:",
  "UI Text": "نصوص الواجهة",
  "UI Text Settings": "إعدادات نصوص الواجهة",
  "UNPAID": "غير مدفوع",
  "URGENT": "عاجل",
  "Unable to load your business": "تعذر تحميل نشاطك",
  "Unavailable": "غير متاح",
  "Uncategorized": "غير مصنف",
  "Unchecked applies from the next billing cycle instead.": "إذا لم يُحدد، يُطبق بدءًا من دورة الفوترة التالية.",
  "Unit": "الوحدة",
  "Unknown": "غير معروف",
  "Unknown Branch": "فرع غير معروف",
  "Unknown Item": "عنصر غير معروف",
  "Unnamed": "بدون اسم",
  "Unpaid": "غير مدفوع",
  "Up to 5 MB · 1,000 rows per import": "حتى 5 ميغابايت · 1,000 صف لكل استيراد",
  "Upcoming Appointments": "المواعيد القادمة",
  "Update": "تحديث",
  "Update Category": "تحديث التصنيف",
  "Update Employee": "تحديث الموظف",
  "Update Item": "تحديث العنصر",
  "Update Recipe": "تحديث الوصفة",
  "Update Report": "تحديث التقرير",
  "Update Restaurant": "تحديث المطعم",
  "Update Table": "تحديث الطاولة",
  "Update restaurant information and settings": "تحديث معلومات المطعم وإعداداته",
  "Updating...": "جارٍ التحديث...",
  "Upload Excel or CSV": "رفع Excel أو CSV",
  "Upload Image File": "رفع ملف صورة",
  "Upload Theme": "رفع ثيم",
  "Upload a different receipt": "رفع إيصال آخر",
  "Upload a storefront theme": "رفع ثيم لواجهة المتجر",
  "Upload and save theme": "رفع الثيم وحفظه",
  "Upload failed. Please try again.": "فشل الرفع. حاول مرة أخرى.",
  "Upload image": "رفع صورة",
  "Upload once. Match your columns. Save your catalogue in bulk.": "ارفع مرة واحدة. طابق الأعمدة. احفظ كتالوجك دفعة واحدة.",
  "Upload one validated theme package and use it for your restaurant, shop, or appointment website.": "ارفع حزمة ثيم معتمدة واستخدمها لموقع مطعمك أو متجرك أو مواعيدك.",
  "Upload transfer receipt": "رفع إيصال التحويل",
  "Uploaded": "تم الرفع",
  "Uploaded files are treated as design data. Scripts and arbitrary HTML are never executed.": "تُعامل الملفات المرفوعة كبيانات تصميم فقط. لا يتم تنفيذ أي سكربتات أو HTML.",
  "Uploaded theme is live": "الثيم المرفوع مفعّل الآن",
  "Uploaded theme paused": "تم إيقاف الثيم المرفوع مؤقتًا",
  "Uploaded theme removed": "تم حذف الثيم المرفوع",
  "Uploading...": "جارٍ الرفع...",
  "Uploading…": "جارٍ الرفع…",
  "Use Image URL": "استخدام رابط صورة",
  "Use Selected Image": "استخدام الصورة المحددة",
  "Use a link-viewable sheet. For private sheets, download Excel or CSV from Google Sheets and upload it here.": "استخدم جدولًا قابلًا للعرض بالرابط. للجداول الخاصة، نزّل ملف Excel أو CSV من Google Sheets وارفعه هنا.",
  "User": "المستخدم",
  "Username": "اسم المستخدم",
  "Username *": "اسم المستخدم *",
  "Uses MySQL - for multi-device/production environments": "يستخدم MySQL - لبيئات الإنتاج والأجهزة المتعددة",
  "Uses SQLite - perfect for single-device setup": "يستخدم SQLite - مثالي لجهاز واحد",
  "Variant Name *": "اسم الخيار *",
  "Variant added": "تمت إضافة الخيار",
  "Variant name is required": "اسم الخيار مطلوب",
  "Variant removed": "تم حذف الخيار",
  "Variant updated": "تم تحديث الخيار",
  "Variants": "الخيارات",
  "Vegan": "نباتي صرف",
  "Vegetarian": "نباتي",
  "Very Late (30+ min)": "متأخر جدًا (+30 دقيقة)",
  "Vibrant - Playful Shelves": "حيوي - رفوف مرحة",
  "View": "عرض",
  "View Inventory": "عرض المخزون",
  "View Order Details": "عرض تفاصيل الطلب",
  "View QR Code": "عرض رمز QR",
  "View Reports": "عرض التقارير",
  "View all": "عرض الكل",
  "View and export business reports": "عرض تقارير النشاط وتصديرها",
  "View details": "عرض التفاصيل",
  "View image {v0}": "عرض الصورة {v0}",
  "View sales reports and analytics": "عرض تقارير المبيعات والتحليلات",
  "View website": "عرض الموقع",
  "View {name}": "عرض {name}",
  "View: Normal": "العرض: عادي",
  "Visits": "الزيارات",
  "WALK-IN": "زبون حضوري",
  "Wait:": "الانتظار:",
  "Waiter": "نادل",
  "Waiting for payment": "بانتظار الدفع",
  "Waiting for the customer to upload": "بانتظار رفع العميل للإيصال",
  "Walk-in": "حضوري",
  "Walk-in Customer": "زبون حضوري",
  "Warning Color": "لون التحذير",
  "Warning: This will replace all current data!": "تحذير: سيؤدي هذا إلى استبدال جميع البيانات الحالية!",
  "We appreciate your business": "نقدّر تعاملك معنا",
  "We appreciate your business and hope to see you again soon!": "نقدّر تعاملك معنا ونأمل رؤيتك قريبًا!",
  "We could not find this order.": "تعذر العثور على هذا الطلب.",
  "We could not place your order. Please try again.": "تعذر إرسال طلبك. حاول مرة أخرى.",
  "We've received your request for": "لقد استلمنا طلبك لـ",
  "Website": "الموقع الإلكتروني",
  "Website & Themes": "الموقع والثيمات",
  "Website (Optional)": "الموقع الإلكتروني (اختياري)",
  "Website language": "لغة الموقع",
  "Weekly hours": "ساعات العمل الأسبوعية",
  "Weekly hours saved": "تم حفظ ساعات العمل الأسبوعية",
  "Welcome Message": "رسالة الترحيب",
  "Welcome back": "مرحبًا بعودتك",
  "Welcome back, {v0}!": "مرحبًا بعودتك، {v0}!",
  "Welcome back.": "مرحبًا بعودتك.",
  "Welcome bonus (points)": "نقاط الترحيب",
  "Welcome guests, assign their visit, and keep every table on schedule.": "استقبل الضيوف، ونظّم زياراتهم، وحافظ على جدول كل طاولة.",
  "Welcome!": "أهلًا بك!",
  "Welcome! Your account is ready.": "أهلًا بك! حسابك جاهز.",
  "Welcome, {v0}!": "أهلًا بك، {v0}!",
  "We’re on it": "نعمل على طلبك",
  "What are you craving?": "ماذا تشتهي؟",
  "What are you looking for?": "عمّ تبحث؟",
  "What are you setting up?": "ماذا تريد أن تُنشئ؟",
  "What customers can book": "ما يمكن للعملاء حجزه",
  "What customers can book an appointment for": "الخدمات التي يمكن للعملاء حجز موعد لها",
  "What kind of business is this?": "ما نوع هذا النشاط؟",
  "WhatsApp": "واتساب",
  "WhatsApp Marketing": "التسويق عبر واتساب",
  "WhatsApp QR code": "رمز QR لواتساب",
  "WhatsApp connected!": "تم ربط واتساب!",
  "WhatsApp disconnected": "تم قطع اتصال واتساب",
  "WhatsApp marketing": "التسويق عبر واتساب",
  "WhatsApp → Settings → Linked Devices → Link a Device": "واتساب ← الإعدادات ← الأجهزة المرتبطة ← ربط جهاز",
  "When customers can book an appointment with you": "الأوقات التي يمكن للعملاء حجز موعد فيها",
  "When it reaches 0 it shows as \"Out of stock\" on your website and can't be ordered. You get an email when it runs low.": "عند وصوله إلى 0 يظهر \"نفد المخزون\" على موقعك ولا يمكن طلبه. وتصلك رسالة عند انخفاضه.",
  "When off, the \"Reserve a table\" button is hidden from your website.": "عند الإيقاف، يُخفى زر \"احجز طاولة\" من موقعك.",
  "With Salary": "برواتب",
  "Working…": "جارٍ العمل…",
  "Worksheet": "ورقة العمل",
  "Write a message first": "اكتب رسالة أولًا",
  "Wrong number - re-enter": "رقم خاطئ - أعد الإدخال",
  "X (Twitter)": "X (تويتر)",
  "YOU'RE INVITED": "أنت مدعو",
  "Yearly": "سنوي",
  "Yes. In Settings choose English, Arabic, or both - customers can then switch language themselves.": "نعم. من الإعدادات اختر الإنجليزية أو العربية أو كلتيهما - ويمكن للعملاء حينها تبديل اللغة بأنفسهم.",
  "Yes. Plans are billed monthly and you can cancel from your Billing page at any time.": "نعم. تُدفع الخطط شهريًا ويمكنك الإلغاء من صفحة الفوترة في أي وقت.",
  "Yesterday": "أمس",
  "You are being taken to Stripe to pay by card.": "يتم تحويلك إلى Stripe للدفع بالبطاقة.",
  "You can add up to {count} photos": "يمكنك إضافة حتى {count} صور",
  "You can search by order code (CAS-20251028-0002) or PIN (69709299)": "يمكنك البحث برمز الطلب (CAS-20251028-0002) أو PIN (69709299)",
  "You choose: cash, card through your own Stripe account, or bank transfer where the customer uploads the receipt for you to approve.": "أنت تختار: نقدًا، أو بالبطاقة عبر حساب Stripe الخاص بك، أو تحويلًا بنكيًا يرفع فيه العميل الإيصال لتوافق عليه.",
  "You don't have permission to access this page.": "ليس لديك صلاحية للوصول إلى هذه الصفحة.",
  "You'll transfer to:": "ستحوّل إلى:",
  "YouTube": "يوتيوب",
  "Your Restaurants": "مطاعمك",
  "Your account": "حسابك",
  "Your basket is empty": "سلتك فارغة",
  "Your bookings at a glance": "حجوزاتك في لمحة",
  "Your business online.": "نشاطك على الإنترنت.",
  "Your business's contact number": "رقم التواصل لنشاطك",
  "Your business's email address": "البريد الإلكتروني لنشاطك",
  "Your card payment went through.": "تمت عملية الدفع بالبطاقة.",
  "Your cart": "سلتك",
  "Your cart (": "سلتك (",
  "Your cart is empty": "سلتك فارغة",
  "Your dashboard and your website work in both languages, right-to-left included.": "لوحة التحكم وموقعك يعملان باللغتين، مع دعم الكتابة من اليمين إلى اليسار.",
  "Your items": "عناصرك",
  "Your last payment didn't go through. Update your payment method to keep your business online.": "لم تنجح آخر عملية دفع. حدّث طريقة الدفع لإبقاء نشاطك متاحًا.",
  "Your monthly subscription, payment method and invoices.": "اشتراكك الشهري وطريقة الدفع والفواتير.",
  "Your name": "اسمك",
  "Your next appointment": "موعدك القادم",
  "Your next visit,": "زيارتك القادمة،",
  "Your order": "طلبك",
  "Your order is awaiting confirmation. Payment is due {v0}.": "طلبك بانتظار التأكيد. الدفع مستحق {v0}.",
  "Your order is ready": "طلبك جاهز",
  "Your order is reserved. Complete the bank transfer below so the store can start on it.": "تم حجز طلبك. أكمل التحويل البنكي أدناه ليبدأ المتجر في تجهيزه.",
  "Your order is waiting for card payment.": "طلبك بانتظار الدفع بالبطاقة.",
  "Your order is waiting for payment. You'll pay on Stripe's secure page.": "طلبك بانتظار الدفع. ستدفع عبر صفحة Stripe الآمنة.",
  "Your own web address is live the moment you sign up, with templates made for your business.": "عنوان موقعك الخاص جاهز فور التسجيل، مع قوالب مصممة لنشاطك.",
  "Your own website": "موقعك الخاص",
  "Your payment is still processing. This page will update.": "لا يزال الدفع قيد المعالجة. ستتحدث هذه الصفحة.",
  "Your reservation is pending until the restaurant confirms it.": "حجزك معلق حتى يؤكده المطعم.",
  "Your subheading will appear here.": "سيظهر عنوانك الفرعي هنا.",
  "Your subscription ends on {date} and will not renew.": "ينتهي اشتراكك في {date} ولن يتجدد.",
  "Your table is reserved for 90 minutes": "طاولتك محجوزة لمدة 90 دقيقة",
  "Your website has been updated": "تم تحديث موقعك",
  "Your weekly hours": "ساعات عملك الأسبوعية"
}
